import { render, staticRenderFns } from "./alt-logo-min.vue?vue&type=template&id=11ba4844&scoped=true&"
var script = {}
import style0 from "./alt-logo-min.vue?vue&type=style&index=0&id=11ba4844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba4844",
  null
  
)

export default component.exports